import { IAPIKey } from "../../../entities/src/apiKey";
import { Modelable } from "../../../entities/src/modelable";

export class APIKey implements Modelable<IAPIKey> {
    constructor(public data: IAPIKey) {}
}
